export { default } from './BatchAddedToShelfWorkflow';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BatchAddedToShelfWorkflow/index.js